<template>
    <div class="theme-container">
        <div class="m-bottom-20">
            <!-- <a-select class="width-160" v-model="params.klass_id" placeholder="请选择所属班级" :allowClear="false"
                @change="getThemeList()">
                <a-select-option v-for="item in klassList" :value="item.id" :key="item.id">
                    {{ item.name }}
                </a-select-option>
            </a-select> -->
            <a-select class="width-160 m-left-10" v-model="themeStatus" placeholder="请选择主题状态" @change="statusChange"
                allowClear>
                <a-select-option value="ACTIVE" key="ACTIVE">使用中</a-select-option>
                <a-select-option value="ARCHIVED" key="ARCHIVED">已归档</a-select-option>
            </a-select>
            <!-- <a-input icon="search" class="width-160 m-left-10" v-model="params.name" placeholder="请输入主题名称"
                @change="getThemeList('name')" allowClear>
                <a-icon slot="prefix" style="color: #999999;" type="search" />
            </a-input> -->
            <a-button class="fr" icon="plus" @click="editTheme()">添加主题</a-button>
        </div>

        <a-table :loading="loading" :columns="tableColumns" :data-source="tableSource" :rowKey="(record) => record.id"
            :pagination="false" :bordered="false">
            <template slot="icon_url" slot-scope="text">
                <!-- <img class="theme-logo" :src="text"> -->
                <span class="theme-logo" :style="getBgStyle"></span>
            </template>
            <!-- <template slot="background_image_url" slot-scope="text">
                <span class="theme-background" :style="getBgStyle(text)"></span>
            </template> -->
            <template slot="operation" slot-scope="text, record">
                <div class="theme-table_btn">
                    <a class="theme-table_btn m-right-20" href="javascript:;" @click="updateHandle(record)">
                        <svg-icon iconClass="eye"></svg-icon>
                        <span class="theme-table_btn_text">{{ record.status === 'ACTIVE' ? "归档" : "恢复" }}</span>
                    </a>
                    <a class="theme-table_btn m-right-20" href="javascript:;" @click="editTheme(record)">
                        <svg-icon iconClass="edit"></svg-icon>
                        <span class="theme-table_btn_text">编辑</span>
                    </a>
                    <a class="theme-table_btn del-color" :class="{ 'disalbed-color': record.tagged_items.length }"
                        href="javascript:;" @click="delHandle(record)">
                        <svg-icon iconClass="eye"></svg-icon>
                        <span class="theme-table_btn_text">删除</span>
                    </a>
                </div>
            </template>
        </a-table>
    </div>
</template>
  
<script>
import { getThemeColumns } from "./constant";
import ThemeService from "@/api/themeService";
import { mapGetters } from "vuex";
import themeImage from "@/assets/images/theme.png"
export default {
    name: "school",
    components: {},
    data() {
        return {
            loading: false,
            tableColumns: getThemeColumns(),
            tableSource: [],
            params: {
                klass_id: undefined,
                include_archived: true,
            },
            themeStatus: "ACTIVE"
        }
    },

    computed: {
        ...mapGetters(["klassList"]),
		getBgStyle() {
            return {
                background: `url(${themeImage}) no-repeat center center`,
            };
		},
    },

    created() {
        this.params.klass_id = this.$route.query.klass_id;
        this.getThemeList();
    },

    methods: {
        getKlassList(isForce = false) {
            this.loading = true;
            this.$store.dispatch("getKlassListService", { isForce }).then(res => {
                this.params.klass_id = res[0].id;
                this.getThemeList();
            }).catch(() => {
                this.loading = false;
            })
        },

        getThemeList() {
            this.loading = true;
            ThemeService.getThemeListService(this.params).then(res => {
                this.loading = false;
                this.originSource = res || [];
                this.statusChange();
            }).catch(() => {
                this.loading = false;
            })
        },

        statusChange() {
            if (this.themeStatus) {
                this.tableSource = this.originSource.filter(item => item.status === this.themeStatus);
            } else {
                this.tableSource = [...this.originSource];
            }
        },

        editTheme(record) {
            if (record) {
                this.$router.push({ name: "updateTheme", query: { klass_id: this.params.klass_id, id: record.id } });
            } else {
                this.$router.push({ name: "createTheme", query: { klass_id: this.params.klass_id } });
            }
        },

        delHandle(record) {
            if (record.tagged_items.length) {
                return;
            }
            this.$confirm({
                title: "提示信息",
                content: `是否删除当前主题 ${record.name}`,
                okText: "确定",
                cancelText: "取消",
                onOk: () => {
                    return new Promise((resolve, reject) => {
                        ThemeService.delThemeService({
                            id: record.id,
                        })
                            .then(() => {
                                this.getThemeList();
                                this.$message.success("操作成功");
                                resolve();
                            })
                            .catch(() => {
                                reject();
                                this.$message.error("操作失败，请重新操作");
                            });
                    });
                },
            });
        },

        updateHandle(record) {
            let tips = "归档";
            let requestService = ThemeService.archiveThemeService;
            if (record.status === "ARCHIVED") {
                tips = "恢复";
                requestService = ThemeService.unarchiveThemeService;
            }
            this.$confirm({
                title: "提示信息",
                content: `是否${tips}当前主题 ${record.name}`,
                okText: "确定",
                cancelText: "取消",
                onOk: () => {
                    return new Promise((resolve, reject) => {
                        requestService({
                            id: record.id,
                        })
                            .then(() => {
                                this.getThemeList();
                                this.$message.success("操作成功");
                                resolve();
                            })
                            .catch(() => {
                                reject();
                                this.$message.error("操作失败，请重新操作");
                            });
                    });
                },
            });
        },
    }
}
</script>
  
<style lang="less" scoped>
.theme {
    &-container {
        background: #ffffff;
        min-height: calc(100% - 65px);
        margin-top: 25px;
        padding: 28px 28px 2px 30px;

        .disalbed-color {
            color: rgba(0, 0, 0, 0.25) !important;
            cursor: not-allowed;
        }
    }

    &-logo {
        display: block;
        width: 46px;
        height: 46px;
        margin: 0 auto;
        border-radius: 50%;
        cursor: pointer;
        background-size: cover !important;
        // overflow: hidden;
    }

    &-background {
        display: block;
        width: 100px;
        height: 100px;
        margin: 0 auto;
        cursor: pointer;
        background-size: cover !important;
    }

    &-table {
        &_btn {
            display: flex;
            flex-flow: nowrap row;
            align-items: center;
            justify-content: center;
            line-height: 1;

            &_text {
                margin-left: 5px;
                line-height: 1;
            }
        }
    }
}
</style>